import NoSleep from '@uriopass/nosleep.js';

const noSleep = new NoSleep();
export default noSleep;
